import { render, staticRenderFns } from "./QuickLinksMenu.vue?vue&type=template&id=6ba3301b&scoped=true&"
import script from "./QuickLinksMenu.vue?vue&type=script&lang=js&"
export * from "./QuickLinksMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinksMenu.vue?vue&type=style&index=0&id=6ba3301b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3301b",
  null
  
)

export default component.exports